export default __webpack_public_path__ + "static/media/LotusLogo.fa7e5567.png";